<template>
  <div
    class="modal"
    :class="{ 'is-active': value }">

    <div class="modal-background"
      @click="close()">
    </div>
    
    <div class="modal-content">
      <div class="modal-card">

        <header class="modal-card-head">
          <p class="modal-card-title">Manage Product Categories</p>
          <button
            class="delete"
            aria-label="close"
            @click="close(true)">
          </button>
        </header>

        <div class="modal-card-body has-text-centered">

          <article 
            v-if="categories.length == 0" 
            class="message is-info is-fullwidth">
            <div class="message-body">
              There are no categories
            </div>
          </article>

          <!-- existing categories -->
          <table class="table is-fullwidth is-hoverable" 
            v-if="categories.length > 0 || addingCategory">
            <thead>
              <tr>
                <th 
                  v-for="(header, headerIndex) in headers"
                  :key="headerIndex">
                  {{ header.label }}
                </th>
                <th></th>
              </tr>
            </thead>

            <tbody>
              <tr 
                class="v-centered"
                v-for="category in categories"
                :key="category.id">
                <td
                  v-for="(header, headerIndex) in headers"
                  :key="headerIndex">
                  <component 
                    :is="header.component"
                    :disabled="category.id != editingCategoryId"
                    v-model="category[header.field]">
                  </component>
                </td>
                <td>
                  <div class="buttons buttons-right" v-if="category.id != editingCategoryId">
                    <button 
                      @click="toggleEdit(category.id)"
                      class="button is-small">
                      <span class="icon">
                        <i class="fas fa-edit has-text-grey"></i>
                      </span>
                    </button>
                    <!-- <button 
                      @click="launchConfirmDelete(category.id)"
                      class="button is-small">
                      <span class="icon">
                        <i class="fas fa-trash has-text-grey"></i>
                      </span>
                    </button> -->
                  </div>
                  <div class="buttons buttons-right" v-else>
                    <button 
                      @click="updateCategory({
                        categoryId: category.id,
                        data: { 
                          category: category.category,
                          has_dimensions: category.has_dimensions
                        }
                      }); toggleEdit(category.id)"
                      class="button is-small is-primary">
                      <span class="icon">
                        <i class="fas fa-save"></i>
                      </span>
                    </button>
                    <button 
                      @click="toggleEdit(category.id)"
                      class="button is-small">
                      <span class="icon">
                        <i class="fas fa-times has-text-grey"></i>
                      </span>
                    </button>
                  </div>
                </td>
              </tr>
              <tr class="v-centered" v-if="addingCategory">
                <td>  
                  <v-form :valid.sync="valid" class="row-justified pb-2">
                    <v-text-field 
                      required
                      placeholder="Enter category name"
                      v-model="category.category"/>
                  </v-form>
                </td>
                <td>
                  <v-checkbox
                    v-model="category.has_dimensions"/>
                </td>
                <td>
                  <div class="buttons buttons-right">
                    <button 
                      :disabled="!valid"
                      @click="addNewCategory()"
                      class="button is-primary is-small">
                      <span class="icon">
                        <i class="fas fa-save"></i>
                      </span>
                    </button>
                    <button 
                      @click="addingCategory = false"
                      class="button is-small">
                      <span class="icon">
                        <i class="fas fa-times has-text-grey"></i>
                      </span>
                    </button>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
          <div class="help my-3">
            Note for whether a product category "has dimensions" - this should
            be checked off for products that can be measured in 
            length, width, and height
          </div>

          <button 
            v-if="!addingCategory"
            class="button is-primary is-small" 
            @click="addingCategory = true; editingCategoryId = null">
            Add a Category
          </button>

        </div>

      </div>

      <v-confirm-modal 
        v-model="confirmDelete.state"
        :title="confirmDelete.title"
        :message="confirmDelete.message"
        :type="confirmDelete.type"
        @confirm="deleteConfirmedCb()"
        @cancel="confirmDelete.state = false"/>

    </div>
  </div>
</template>

<script>
import VForm from '@/components/base/VForm'
import VTextField from '@/components/base/VTextField'
import VCheckbox from '@/components/base/VCheckbox'
import VConfirmModal from '@/components/base/VConfirmModal'

import { mapState, mapActions } from 'vuex'

export default {
  props: {
    value: {
      type: Boolean
    }
  },
  components: { VTextField, VForm, VCheckbox, VConfirmModal },
  data() {
    return {
      valid: false,
      category: {
        category: null,
        has_dimensions: false
      },
      addingCategory: false,
      editingCategoryId: null,
      headers: [
        { label: 'Category Name', field: 'category', component: 'VTextField' },
        { label: 'Has Dimensions', field: 'has_dimensions', component: 'VCheckbox' }
      ],
      confirmDelete: {
        state: false,
        title: 'Delete Confirmation',
        message: 'Are you sure you want to delete this Category?',
        type: 'danger'
      },
      deleteConfirmedCb: null
    }
  },
  computed: {
    ...mapState("products", ["categories", "productTypes"])
  },
  methods: {
    ...mapActions("products", [
      "addCategory", "updateCategory", "deleteCategory"
    ]),
    addNewCategory() {
      this.addCategory(this.category)
        .then(() => {
          Object.keys(this.category).forEach(key => {
            this.category[key] = null;
          });
          this.addingCategory = false;
        });
    },
    toggleEdit(categoryId) {
      if (this.editingCategoryId == categoryId) {
        this.editingCategoryId = null;
      } else {
        this.editingCategoryId = categoryId;
      }
    },
    launchConfirmDelete(categoryId) {
      this.deleteConfirmedCb = () => {
        this.deleteCategory(categoryId);
        this.confirmDelete.state = false;
      }
      this.confirmDelete.state = true;
    },
    close(clear=false) {
      this.$emit('input', false);
      if (clear) {
        this.clearData();
      }
    },
    clearData() {
      Object.assign(this.$data, this.$options.data.call(this));
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/styles/table.scss';

.row-justified {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  flex-grow: 1;
}

.modal-card {
  border-radius: 6px;
}
</style>